module.exports = __webpack_public_path__ + "img/service_black.420724f1.png";